import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

export function AreaDetailsListItemComponent({ onClick, isActive, name, hidden }) {
  const classes = isActive ? 'selected' : '';
  const caret = isActive ? (
    <ViewerPrimaryColorUserStyle domStyle="borderLeftColor">
      <div className="right-caret" />
    </ViewerPrimaryColorUserStyle>
  ) : '';
  return (
    <li className={classes} hidden={hidden}>
      <ViewerPrimaryColorUserStyle domStyle={isActive && 'color'}>
        <a tabIndex="0" onClick={onClick}>
          { name } { caret }
        </a>
      </ViewerPrimaryColorUserStyle>
    </li>
  );
}

AreaDetailsListItemComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string,
  isActive: PropTypes.bool,
  hidden: PropTypes.bool,
};

export default AreaDetailsListItemComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaDetails/AreaDetailsListItem.js